module.exports = __webpack_public_path__ + "img/card.504292a9.jpg";